var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 26.3275C32 26.1725 32.214 25.9995 32.5 25.9995H35.5C35.786 25.9995 36 26.1725 36 26.3275V27.9995H32V26.3275ZM43 27.9995H42H38V26.3275C38 25.0435 36.879 23.9995 35.5 23.9995H32.5C31.121 23.9995 30 25.0435 30 26.3275V27.9995H26H25C24.45 27.9995 24 28.4505 24 28.9995C24 29.5495 24.45 29.9995 25 29.9995H26V40.9995C26 42.6545 27.346 43.9995 29 43.9995H39C40.654 43.9995 42 42.6545 42 40.9995V29.9995H43C43.55 29.9995 44 29.5495 44 28.9995C44 28.4505 43.55 27.9995 43 27.9995Z",
    fill: "#DA515E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#DA515E",
    fillOpacity: 0.08
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.1a89bf70.svg";
export { ForwardRef as ReactComponent };